import { Component, Input } from '@angular/core';

@Component({
  selector: 'cm-restriction-card-skeleton',
  templateUrl: './restriction-card-skeleton.component.html',
  styleUrls: ['../../card/card.component.scss', './restriction-card-skeleton.component.scss'],
})
export class RestrictionCardSkeletonComponent {
  @Input() isSmall = false;

  constructor() {}
}
